import workspaceQuery from 'graphql/queries/nominal/NominalTemplateWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/nominal/NominalTemplateListQuery.graphql';
import instanceQuery from 'graphql/queries/nominal/NominalTemplateQuery.graphql';
import defaultQuery from 'graphql/queries/nominal/NominalTemplateDefault.graphql';
import mutationQuery from 'graphql/mutations/nominal/NominalTemplateMutation.graphql';
import temporaryMutationQuery from 'graphql/mutations/nominal/SaveNominalTemplateTempMutation.graphql';
import fragment from 'graphql/fragments/nominal/NominalTemplateFragment.graphql';

const NominalTemplate = {
  type: 'NominalTemplate',
  title: 'Nominal Templates',
  formUrl: '/Nominal/Template/Details/',
  formTitle: 'Nominal Templates',
  workspaceUrl: '/Nominal/Template/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  temporarySave: temporaryMutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'name',
  },
  fragment,
  screenReference: 'NOMINAL_TEMPLATE',
};

export default NominalTemplate;
